import { inject, Injectable } from '@angular/core'
import { forkJoin, map, Observable, of, switchMap } from 'rxjs'
import { ExternalFormsService } from 'superlikers-microsites-api'

import { circuitAdapter } from '@core/adapters/circuits.adapter'
import { Circuit } from '@core/interfaces/circuits.interface'

@Injectable({
  providedIn: 'root'
})
export class CircuitsService {
  private externalFormsService = inject(ExternalFormsService)

  /**
   * Obtiene los circuitos para una categoría específica
   *
   * @param {string} category - Categoría de los circuitos a obtener
   * @param {number} page - Número de página para la paginación
   * @returns {Observable<Circuit[]>} Observable con array de circuitos adaptados
   */
  fetchCircuits(category: string, page: number): Observable<Circuit[]> {
    const list$ = this.externalFormsService.getExternalsFormList({ page, category })

    return list$.pipe(
      switchMap(list => {
        if (list.data.length === 0) return of([])

        const fields$ = list.data.map(item => this.fetchCircuitFields(item._id, category))
        return forkJoin(fields$)
      })
    )
  }

  /**
   * Obtiene los campos de un circuito
   *
   * @param {string} listId - Identificador único del circuito
   * @param {string} category - Categoría del circuito
   * @returns {Observable<Circuit>} Observable con el circuito adaptado
   */
  fetchCircuitFields(listId: string, category: string) {
    return this.externalFormsService.getExternalsFormFields(listId).pipe(
      map(response => {
        return circuitAdapter(response.object.id, response.object.fields, category)
      })
    )
  }
}
